import { render } from "./DashboardFournisseur.vue?vue&type=template&id=00f0829a&scoped=true&ts=true"
import script from "./DashboardFournisseur.vue?vue&type=script&lang=ts"
export * from "./DashboardFournisseur.vue?vue&type=script&lang=ts"

import "./DashboardFournisseur.vue?vue&type=style&index=0&id=00f0829a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f0829a"]])

export default __exports__